App.SettingsController = Em.Controller.extend
  session:  Em.inject.service()
  env:      Em.inject.service('environment')

  isBoard2linkEnabled: Em.computed.alias('env.features.boardShowBoard2Link')

  isExternalIntegrationsLink: localStorage.getItem('integrationsSettings') == 'false'